import { i18n } from 'i18n/i18n'

export const getSafeI18nTextOrEmpty = (translationKey: string): string => {
  const translatedText = i18n(translationKey)
  return !!translatedText && translatedText !== 'undefined' ? translatedText : ''
}
